import React, { FC, SVGProps } from "react"

import { useTheme } from "@emotion/react"

export const IconFailure: FC<SVGProps<SVGSVGElement>> = props => {
  const theme = useTheme()
  return (
    <svg
      fill="none"
      height="1rem"
      viewBox="0 0 16 16"
      width="1rem"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title lang="en">Failure</title>
      <path
        d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
        fill={theme.colors.failureMedium}
      />
      <mask fill={theme.colors.white} id="path-2-inside-1_1330_4350">
        <path
          clipRule="evenodd"
          d="M8.66659 5.33317C8.66659 4.96498 8.36811 4.6665 7.99992 4.6665C7.63173 4.6665 7.33325 4.96498 7.33325 5.33317V7.99984C7.33325 8.36803 7.63173 8.6665 7.99992 8.6665C8.36811 8.6665 8.66659 8.36803 8.66659 7.99984V5.33317ZM7.99992 11.3332C8.36811 11.3332 8.66659 11.0347 8.66659 10.6665C8.66659 10.2983 8.36811 9.99984 7.99992 9.99984C7.63173 9.99984 7.33325 10.2983 7.33325 10.6665C7.33325 11.0347 7.63173 11.3332 7.99992 11.3332Z"
          fillRule="evenodd"
        />
      </mask>
      <path
        clipRule="evenodd"
        d="M8.66659 5.33317C8.66659 4.96498 8.36811 4.6665 7.99992 4.6665C7.63173 4.6665 7.33325 4.96498 7.33325 5.33317V7.99984C7.33325 8.36803 7.63173 8.6665 7.99992 8.6665C8.36811 8.6665 8.66659 8.36803 8.66659 7.99984V5.33317ZM7.99992 11.3332C8.36811 11.3332 8.66659 11.0347 8.66659 10.6665C8.66659 10.2983 8.36811 9.99984 7.99992 9.99984C7.63173 9.99984 7.33325 10.2983 7.33325 10.6665C7.33325 11.0347 7.63173 11.3332 7.99992 11.3332Z"
        fill={theme.colors.white}
        fillRule="evenodd"
      />
      <path
        d="M7.99992 5.6665C7.81582 5.6665 7.66659 5.51727 7.66659 5.33317H9.66659C9.66659 4.4127 8.92039 3.6665 7.99992 3.6665V5.6665ZM8.33325 5.33317C8.33325 5.51727 8.18401 5.6665 7.99992 5.6665V3.6665C7.07944 3.6665 6.33325 4.4127 6.33325 5.33317H8.33325ZM8.33325 7.99984V5.33317H6.33325V7.99984H8.33325ZM7.99992 7.6665C8.18401 7.6665 8.33325 7.81574 8.33325 7.99984H6.33325C6.33325 8.92031 7.07944 9.6665 7.99992 9.6665V7.6665ZM7.66659 7.99984C7.66659 7.81574 7.81582 7.6665 7.99992 7.6665V9.6665C8.92039 9.6665 9.66659 8.92031 9.66659 7.99984H7.66659ZM7.66659 5.33317V7.99984H9.66659V5.33317H7.66659ZM7.66659 10.6665C7.66659 10.4824 7.81582 10.3332 7.99992 10.3332V12.3332C8.92039 12.3332 9.66659 11.587 9.66659 10.6665H7.66659ZM7.99992 10.9998C7.81582 10.9998 7.66659 10.8506 7.66659 10.6665H9.66659C9.66659 9.74603 8.92039 8.99984 7.99992 8.99984V10.9998ZM8.33325 10.6665C8.33325 10.8506 8.18401 10.9998 7.99992 10.9998V8.99984C7.07944 8.99984 6.33325 9.74603 6.33325 10.6665H8.33325ZM7.99992 10.3332C8.18401 10.3332 8.33325 10.4824 8.33325 10.6665H6.33325C6.33325 11.587 7.07944 12.3332 7.99992 12.3332V10.3332Z"
        fill={theme.colors.white}
        mask="url(#path-2-inside-1_1330_4350)"
      />
    </svg>
  )
}
